import Bugsnag from '@bugsnag/js'
import { Box } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { postOvertimePayroll } from 'services/api/modules/payroll/payroll-edit'

const RemoveOvertimeModal = ({ employee_id, time_id, children }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  const queryClient = useQueryClient()
  const { mutate: submitOvertime } = useMutation(postOvertimePayroll, {
    onSuccess: () => {
      queryClient.invalidateQueries('retrieveEmployeeData')
      setModalOpen(false)
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })
  const handleRemove = () => {
    submitOvertime({ time_id: time_id, employee_id: employee_id, data: { overtime: [] } })
  }
  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Are you sure you want to remove this?"
        subtitle="All the overtime items will be removed for this employee"
        footerButtons
        firstBtnLabel={'Remove'}
        firstBtnHandle={handleRemove}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}
export default RemoveOvertimeModal
